// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 479) return "static/chunks/479-5323926993497b3b.js";
	if (chunkId === 618) return "static/chunks/618-b90a91e738de5090.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"418":"36eb25b00dc3d9aa","536":"8191c8fedb87d0ba"}[chunkId] + ".js";
};